export default class AllowanceActions {

  static NEW_DATA = 'NEW_DATA';
  static UPDATE_DATA='UPDATE_DATA';
  static SHOW_DATA='SHOW_DATA';
  static VIEW_DATA='VIEW_DATA';
  static DELETE_DATA='DELETE_DATA';
  static ON_SUBMIT='ON_SUBMIT';
  static ERROR_DATA='ERROR_DATA';
  static PROCESS_DATA='PROCESS_DATA';
  static RESET_DATA='RESET_DATA';
  static GET_HELPER_ALLOWANCE='GET_HELPER_ALLOWANCE';
  static SUCCESS_DATA='SUCCESS_DATA';
  static ERROR_SERVER='ERROR_SERVER';
  static RESET_LIST='RESET_LIST';
  static submit(){
    return {
      type: AllowanceActions.ON_SUBMIT
    };
  }

  static create(data) {
    return {
      type: AllowanceActions.NEW_DATA,
      payload: data
    };
  }

  static update(data) {
    return {
      type: AllowanceActions.UPDATE_DATA,
      payload: data
    };
  }

  static view(data) {
    return {
      type: AllowanceActions.VIEW_DATA,
      payload: data
    };
  }

  static delete(data) {
    return {
      type: AllowanceActions.DELETE_DATA
    };
  }

  static list(data) {
    return {
      type: AllowanceActions.SHOW_DATA,
      payload: data
    };
  }
  static resetList() {
    return {
      type: AllowanceActions.RESET_LIST
    };
  }
  static error(error){
    return {
      type: AllowanceActions.ERROR_DATA,
      payload: error
    };
  }
  static success(){
    return {
      type: AllowanceActions.SUCCESS_DATA,
    };
  }
  static process(){
    return {
      type: AllowanceActions.PROCESS_DATA,
    };
  }
  static reset(){
    return {
      type: AllowanceActions.RESET_DATA,
    };
  }
  static helper(data){
    return {
      type: AllowanceActions.GET_HELPER_ALLOWANCE,
      payload:data
    };
  }
  static errorInternal(error){
    return {
      type: AllowanceActions.ERROR_SERVER,
      payload: error
    };
  }
}